var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ibox-content" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tipoCita.nombre,
                      expression: "tipoCita.nombre",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre", type: "text" },
                  domProps: { value: _vm.tipoCita.nombre },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.tipoCita, "nombre", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Abreviatura")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tipoCita.abrev,
                      expression: "tipoCita.abrev",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Abreviatura", type: "text" },
                  domProps: { value: _vm.tipoCita.abrev },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.tipoCita, "abrev", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.list.length > 0 ? _c("hr") : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.list, function (item, index) {
          return _c("div", { key: index, staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Establecimiento " + _vm._s(index + 1))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("multiselect", {
                      attrs: {
                        placeholder: "Selecciona establecimiento",
                        label: "nombre",
                        multiple: true,
                        taggable: true,
                        "track-by": "id",
                        options: _vm.establecimientos_list,
                      },
                      model: {
                        value: item.establecimientos,
                        callback: function ($$v) {
                          _vm.$set(item, "establecimientos", $$v)
                        },
                        expression: "item.establecimientos",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Estrategia " + _vm._s(index + 1))]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.estrategia,
                          expression: "item.estrategia",
                        },
                      ],
                      staticClass: "custom-select",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            item,
                            "estrategia",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v("Seleccione un elemento"),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.estrategias_list,
                        function (estrategia, index3) {
                          return _c(
                            "option",
                            { key: index3, domProps: { value: estrategia.id } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(estrategia.nombre) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Eliminar")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function ($event) {
                          return _vm.eliminar(index)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]),
              ]),
            ]),
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "a",
              { attrs: { href: "javascript:void(0)" }, on: { click: _vm.add } },
              [_vm._v("Añadir Estrategia")]
            ),
          ]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-footer" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 offset-md-8" }, [
          _c("div", { staticClass: "btn-group float-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit" },
                on: { click: _vm.save },
              },
              [
                _c("i", { staticClass: "fal fa-save" }),
                _vm._v(" Guardar\n                    "),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }